import { __awaiter, __generator } from '../../node_modules/tslib/tslib.es6.js';
import { styled, Grid, useTheme } from '@mui/material';
import React from 'react';
import { AnalyticsTrackingEvent } from '../../analytics/events.js';
import { FacebookIcon } from '../../assets/svg/footer_facebook.js';
import { InstagramIcon } from '../../assets/svg/footer_instergram.js';
import { PinterestIcon } from '../../assets/svg/footer_pinterest.js';
import { TiktokIcon } from '../../assets/svg/footer_tiktok.js';
import { TwitterIcon } from '../../assets/svg/footer_twitter.js';
import { YoutubeIcon } from '../../assets/svg/footer_youtube.js';
import brandclub_colors from '../../colors/brandclubColors.js';
import { TABLET_SCREEN_SIZE, TABLET_HORIZONTAL_PADDING, MOBILE_SCREEN_SIZE, MOBILE_HORIZONTAL_PADDING, DESKTOP_SCREEN_SIZE, DESKTOP_HORIZONTAL_PADDING, UNIVERSAL_STORE_SITE } from '../../utils/constants/Constants.js';
import { sendTextCallback } from '../../utils/textMessage.js';
import BrandclubPhoneInput, { BCPhoneInputVariant } from '../components/BrandclubPhoneInput/index.js';
import { GenericContainer } from '../components/GenericContainer.js';
import { SiteBrandingType } from '../type.js';

var _a, _b, _c;
var isDefined = function (value) { return value != null; };
var FooterContainer = styled(GenericContainer)((_a = {
        zIndex: 1,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: "0 5%",
        boxSizing: 'border-box',
        backgroundColor: brandclub_colors.blueWhite
    },
    _a["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
        padding: "0 ".concat(TABLET_HORIZONTAL_PADDING, "px"),
    },
    _a["@media screen and (max-width: ".concat(MOBILE_SCREEN_SIZE, "px)")] = {
        padding: "0 ".concat(MOBILE_HORIZONTAL_PADDING, "px"),
    },
    _a));
var GetTheAppTitle = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        fontSize: 16,
        fontWeight: 600,
        paddingBottom: 12,
        color: theme.palette.primary.main,
        maxWidth: 301,
    });
});
var FooterContentContainer = styled(Grid)(function (_a) {
    var _b, _c, _d;
    var theme = _a.theme;
    return (_b = {
            '&.last-footer-content': {
                borderTop: '1px solid #e5e5e5',
            },
            padding: '54px 0',
            maxWidth: DESKTOP_SCREEN_SIZE - DESKTOP_HORIZONTAL_PADDING * 2,
            width: '100%',
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            '.invite_sec': {
                flex: 4,
                minWidth: 300,
                '.brandName': {
                    fontSize: 20,
                    fontWeight: 700,
                    paddingBottom: 12,
                    color: theme.palette.primary.main,
                    maxWidth: 301,
                },
                '.subtitle': {
                    fontSize: 14,
                    fontWeight: 500,
                    paddingBottom: 30,
                    color: theme.palette.primary.main,
                    maxWidth: 286,
                },
                '.phone_input': {
                    maxWidth: 285,
                },
            },
            '.links': (_c = {
                    flex: 6,
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '100%'
                },
                _c["@media screen and (max-width: ".concat(MOBILE_SCREEN_SIZE, "px)")] = {
                    flexDirection: 'column',
                    gap: 40,
                },
                _c),
            '.links_sec': {
                minWidth: 160,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                '.label': {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 12,
                },
                '.header': {
                    fontSize: 16,
                    fontWeight: 'bold',
                    fontStretch: 'normal',
                    fontStyle: 'normal',
                    letterSpacing: 'normal',
                    textAlign: 'left',
                    color: theme.palette.primary.main,
                },
                a: (_d = {
                        textDecoration: 'none',
                        fontSize: 14,
                        maxWidth: 200,
                        fontWeight: 500,
                        fontStretch: 'normal',
                        fontStyle: 'normal',
                        marginTop: 15,
                        letterSpacing: 'normal',
                        textAlign: 'left',
                        color: theme.palette.primary.main
                    },
                    _d["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
                        marginTop: 7,
                        marginBottom: 3,
                    },
                    _d["@media screen and (max-width: ".concat(MOBILE_SCREEN_SIZE, "px)")] = {
                        marginTop: 7,
                        marginBottom: 3,
                    },
                    _d),
                '.desc': {
                    fontSize: 16,
                    fontWeight: 500,
                    fontStretch: 'normal',
                    fontStyle: 'normal',
                    marginTop: 14,
                    marginBottom: 6,
                    letterSpacing: 'normal',
                    textAlign: 'left',
                    color: theme.palette.primary.main,
                },
                input: {
                    marginTop: 18,
                    marginBottom: 14,
                    width: 260,
                    height: 42,
                    borderRadius: 10,
                    color: theme.palette.primary.main,
                    outline: 'none',
                    paddingLeft: '20px',
                    fontSize: 14,
                    border: "solid 1px ".concat(theme.palette.primary.main),
                    backgroundColor: '#ffffff',
                },
                '::placeholder': {
                    color: theme.palette.primary.main,
                    opacity: 1 /* Firefox */,
                },
                button: {
                    marginTop: 6,
                    height: 41,
                    width: 144,
                    color: 'white',
                    border: 'none',
                    outline: 'none',
                    fontSize: 18,
                    fontWeight: 500,
                    cursor: 'pointer',
                    borderRadius: 50,
                    position: 'relative',
                    backgroundColor: '#16949b',
                },
            }
        },
        _b["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
            flexDirection: 'column',
            padding: '40px 0',
            gap: 40,
            '.links_sec': {},
        },
        _b);
});
var BottomBarContainer = styled(Grid)(function (_a) {
    var _b, _c;
    var theme = _a.theme;
    return (_b = {
            borderTop: '1px solid #e5e5e5',
            maxWidth: DESKTOP_SCREEN_SIZE - DESKTOP_HORIZONTAL_PADDING * 2,
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexDirection: 'row',
            '.bot_nav': (_c = {
                    display: 'flex',
                    flxDirecton: 'row',
                    gap: 50
                },
                _c["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
                    flexDirection: 'column',
                    gap: 15,
                },
                _c["@media screen and (max-width: ".concat(MOBILE_SCREEN_SIZE, "px)")] = {
                    flexDirection: 'column',
                    gap: 15,
                },
                _c.a = {
                    fontSize: 12,
                    fontWeight: 500,
                    color: theme.palette.primary.main,
                    textDecoration: 'none',
                },
                _c),
            '.medias': {
                display: 'flex',
                whiteSpace: 'nowrap',
                a: {
                    margin: '0 0 0 20px',
                    width: 24,
                    height: 24,
                },
                img: {
                    width: 24,
                    height: 24,
                },
            },
            padding: '30px 0 50px 0'
        },
        _b["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
            alignItems: 'flex-start',
            flexDirection: 'column-reverse',
            '.medias': {
                marginBottom: 30,
                a: {
                    margin: '0 10px 0 0',
                },
            },
        },
        _b);
});
var BrandLogo = styled('div')((_b = {
        marginBottom: 20
    },
    _b["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
        position: 'relative',
        top: 'unset',
        left: 'unset',
        maxWidth: 75,
    },
    _b.img = (_c = {
            objectFit: 'contain',
            maxWidth: 125
        },
        _c["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
            maxWidth: 75,
        },
        _c),
    _b));
var LinkOffsetPill = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        fontSize: 12,
        fontWeight: 600,
        paddingBottom: 12,
        backgroundColor: theme.palette.primary.main,
        color: '#ffffff',
        height: 24,
        padding: '0 13px',
        display: 'flex',
        alignItems: 'center',
        borderRadius: 200,
    });
});
var SingleFooter = function (_a) {
    var _b, _c, _d, _e;
    var axios = _a.axios, LinkComponent = _a.LinkComponent, brandEntity = _a.brandEntity, footerConfig = _a.footerConfig, className = _a.className, userProfile = _a.userProfile, trackingParams = _a.trackingParams;
    return (React.createElement(FooterContentContainer, { className: className },
        (footerConfig === null || footerConfig === void 0 ? void 0 : footerConfig.siteBrandingType) === SiteBrandingType.UniversalStore ? (React.createElement("div", { className: "invite_sec" },
            React.createElement("div", { className: "logo" },
                React.createElement(BrandLogo, null,
                    React.createElement(LinkComponent, { to: '/' },
                        React.createElement("img", { loading: "lazy", src: 'https://media.brandclub.com/brandclub/image_asset/brandclub_logo_no_star.svg', alt: "bd_logo" })))),
            React.createElement(GetTheAppTitle, { className: "title", sx: {
                    paddingBottom: userProfile ? '30px' : undefined,
                } }, "Download the app to access rewards"),
            !userProfile && React.createElement("div", { className: "subtitle" }, "Enter your mobile number to get started."),
            React.createElement("div", { className: "phone_input" },
                React.createElement(BrandclubPhoneInput, { userProfile: userProfile, hasHeader: false, buttonText: "Send", variant: BCPhoneInputVariant.DRAWER_MOBILE, handleSendText: function (phoneNumber) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, sendTextCallback(phoneNumber, axios, brandEntity, undefined, trackingParams, AnalyticsTrackingEvent.WEB_APP_SOCIAL_LINK_TEXT_APP_DOWNLOAD_LINK)];
                        });
                    }); } })))) : (footerConfig === null || footerConfig === void 0 ? void 0 : footerConfig.siteBrandingType) === SiteBrandingType.CustomDTCStore ? (React.createElement("div", { className: "invite_sec" },
            React.createElement("div", { className: "brandName" }, (_b = brandEntity === null || brandEntity === void 0 ? void 0 : brandEntity.entity) === null || _b === void 0 ? void 0 : _b.name),
            React.createElement("div", { className: "subtitle" }, footerConfig.customText))) : (React.createElement("div", { className: "invite_sec" },
            React.createElement("div", { className: "brandName" }, (_c = brandEntity === null || brandEntity === void 0 ? void 0 : brandEntity.entity) === null || _c === void 0 ? void 0 : _c.name),
            React.createElement("div", { className: "subtitle" }, "Earn rewards with ".concat((_d = brandEntity === null || brandEntity === void 0 ? void 0 : brandEntity.entity) === null || _d === void 0 ? void 0 : _d.name, " by completing activities, making purchases,\nand syncing your accounts.")))),
        React.createElement("div", { className: "links" }, (_e = footerConfig === null || footerConfig === void 0 ? void 0 : footerConfig.linkSections) === null || _e === void 0 ? void 0 : _e.map(function (section, idx) {
            var _a, _b;
            return (React.createElement("div", { className: "links_sec", key: (_a = section.title) !== null && _a !== void 0 ? _a : idx },
                section.title && React.createElement("div", { className: "header" }, section.title), (_b = section === null || section === void 0 ? void 0 : section.links) === null || _b === void 0 ? void 0 :
                _b.map(function (link) { return (React.createElement(LinkComponent, { key: "".concat(link.label, "-").concat(section.title), to: link.link, onClick: link.onClick },
                    React.createElement("div", { className: "label" },
                        React.createElement("div", { className: "label_text" }, link.label),
                        link.offsetText ? React.createElement(LinkOffsetPill, null, link.offsetText) : null))); })));
        }))));
};
var BrandclubFooter = function (_a) {
    var _b, _c, _d;
    var axios = _a.axios, LinkComponent = _a.LinkComponent, brandEntity = _a.brandEntity, footerConfigs = _a.footerConfigs, className = _a.className, userProfile = _a.userProfile, socialLinks = _a.socialLinks, PhoneInputComponent = _a.PhoneInputComponent;
    var theme = useTheme();
    var linkPrefix = ((_b = footerConfigs === null || footerConfigs === void 0 ? void 0 : footerConfigs[0]) === null || _b === void 0 ? void 0 : _b.siteBrandingType) === SiteBrandingType.CustomDTCStore ? UNIVERSAL_STORE_SITE : '';
    return (React.createElement(FooterContainer, { className: className }, footerConfigs === null || footerConfigs === void 0 ? void 0 :
        footerConfigs.filter(isDefined).map(function (footerConfig, index, allConfigs) {
            return (React.createElement(SingleFooter, { key: footerConfig.siteBrandingType, axios: axios, LinkComponent: LinkComponent, brandEntity: brandEntity, footerConfig: footerConfig, userProfile: userProfile, PhoneInputComponent: PhoneInputComponent, className: allConfigs.length > 1 && allConfigs.length - 1 === index ? 'last-footer-content' : '' }));
        }),
        React.createElement(BottomBarContainer, null,
            React.createElement("div", { className: "bot_nav" },
                ((_c = footerConfigs === null || footerConfigs === void 0 ? void 0 : footerConfigs[0]) === null || _c === void 0 ? void 0 : _c.siteBrandingType) === SiteBrandingType.CustomDTCStore ||
                    ((_d = footerConfigs === null || footerConfigs === void 0 ? void 0 : footerConfigs[0]) === null || _d === void 0 ? void 0 : _d.siteBrandingType) === SiteBrandingType.CustomStore ? null : (React.createElement(LinkComponent, { to: "/" }, "\u00A9 2025 Brandclub")),
                React.createElement(LinkComponent, { to: "".concat(linkPrefix, "/privacy") }, "Privacy Policy"),
                React.createElement(LinkComponent, { to: "".concat(linkPrefix, "/californiaprivacy") }, "California Policy"),
                React.createElement(LinkComponent, { to: "".concat(linkPrefix, "/terms") }, "Terms of Service"),
                React.createElement(LinkComponent, { to: "".concat(linkPrefix, "/endorsement") }, "Endorsement"),
                React.createElement(LinkComponent, { to: "".concat(linkPrefix, "/rewardterms") }, "Reward Terms")),
            React.createElement("div", { className: "medias" }, React.createElement(React.Fragment, null,
                (socialLinks === null || socialLinks === void 0 ? void 0 : socialLinks.youtube) && (React.createElement("a", { href: socialLinks.youtube, target: "blank", className: "social-links", title: "YouTube" },
                    React.createElement(YoutubeIcon, { fill: theme.dtc ? theme.palette.primary.main : undefined }))),
                (socialLinks === null || socialLinks === void 0 ? void 0 : socialLinks.instagram) && (React.createElement("a", { href: socialLinks === null || socialLinks === void 0 ? void 0 : socialLinks.instagram, target: "blank", title: "Instagram" },
                    React.createElement(InstagramIcon, { fill: theme.dtc ? theme.palette.primary.main : undefined }))),
                (socialLinks === null || socialLinks === void 0 ? void 0 : socialLinks.facebook) && (React.createElement("a", { href: socialLinks === null || socialLinks === void 0 ? void 0 : socialLinks.facebook, target: "blank", title: "Facebook" },
                    React.createElement(FacebookIcon, { fill: theme.dtc ? theme.palette.primary.main : undefined }))),
                (socialLinks === null || socialLinks === void 0 ? void 0 : socialLinks.tiktok) && (React.createElement("a", { href: socialLinks === null || socialLinks === void 0 ? void 0 : socialLinks.tiktok, target: "blank", title: "TikTok" },
                    React.createElement(TiktokIcon, { fill: theme.dtc ? theme.palette.primary.main : undefined }))),
                (socialLinks === null || socialLinks === void 0 ? void 0 : socialLinks.x) && (React.createElement("a", { href: socialLinks === null || socialLinks === void 0 ? void 0 : socialLinks.x, target: "blank", title: "X" },
                    React.createElement(TwitterIcon, { fill: theme.dtc ? theme.palette.primary.main : undefined }))),
                (socialLinks === null || socialLinks === void 0 ? void 0 : socialLinks.pinterest) && (React.createElement("a", { href: socialLinks === null || socialLinks === void 0 ? void 0 : socialLinks.pinterest, target: "blank", title: "Pinterest" },
                    React.createElement(PinterestIcon, { fill: theme.dtc ? theme.palette.primary.main : undefined }))))))));
};

export { BrandclubFooter };
//# sourceMappingURL=index.js.map
